import { render, staticRenderFns } from "./EventAddView.vue?vue&type=template&id=516242f8&"
import script from "./EventAddView.vue?vue&type=script&lang=js&"
export * from "./EventAddView.vue?vue&type=script&lang=js&"
import style0 from "./EventAddView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports